import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BoobleModalService } from 'booble-modal';

import { countries } from 'src/app/shared/utils/countries';
import { AuthenticationService } from 'src/app/shared/services';
import { CountryDto } from 'src/app/domain/models/dto/country.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { FinalitiesService } from 'src/app/shared/services/finalities.service';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';
import { NewOrderModalComponent } from '../new-order-modal/new-order-modal.component';

import { AddExistingInvoiceDto } from 'src/app/domain/models/dto/add-existing-invoice.dto';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { AttachInvoiceModalComponent } from 'src/app/pages/orders/shared/components/modals/attach-invoice-modal/attach-invoice-modal.component';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';

declare const $: any;

@Component({
  selector: 'app-add-existing-invoice-modal',
  templateUrl: './add-existing-invoice-modal.component.html',
  styleUrls: ['./add-existing-invoice-modal.component.scss'],
})
export class AddExistingInvoiceModalComponent implements OnInit {
  public loading: boolean;
  companyId: number;
  branchs: string[];
  countries: CountryDto[];
  finalities: FinalitiesDto[];
  private readonly notifier: NotifierService;
  orderForm: FormGroup;
  controlBranch: string = '.js-control-branch';
  controlCurrency: string = '.js-control-currency';
  controlCountry: string = '.js-control-country';
  controlFinality: string = '.js-control-finality';

  get orderFormControl() {
    return this.orderForm.controls;
  }

  get order(): any {
    const order = this.orderForm.value;
    return order;
  }

  constructor(
    private fb: FormBuilder,
    private readonly router: Router,
    notifierService: NotifierService,
    private readonly route: ActivatedRoute,
    private readonly ordersService: OrdersService,
    private readonly companyService: CorporateAccountService,
    private readonly finalitiesService: FinalitiesService,
    private readonly authService: AuthenticationService,
    private modalService: BoobleModalService
  ) {
    this.countries = countries;
    this.companyId = +this.authService.getCompanyId();
    this.notifier = notifierService;
    this.orderForm = fb.group({
      branch: ['', Validators.required],
      corporateAccountId: ['', Validators.required],
      companyName: ['', Validators.required],
      country: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      amount: ['', Validators.required],
      currency: ['', Validators.required],
      finalityId: ['', Validators.required],
      copyinvoiceemail: [false, Validators.required],
    });
  }

  ngOnInit() {
    this.setControls();
    this.companyService.get().subscribe((getResult) => {
      this.branchs = [getResult.data.cnpj];
      this.orderForm.controls['branch'].patchValue(getResult.data.cnpj);
    });

    this.finalitiesService.get().subscribe((getResult) => {
      this.finalities = getResult.data;
    });

    this.orderForm.controls['corporateAccountId'].patchValue(this.companyId);
  }

  setControls() {
    $(this.controlBranch).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    $(this.controlCurrency).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    $(this.controlCountry).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    $(this.controlFinality).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });

    let t = this;
    $(this.controlBranch).on('change', function () {
      t.changeBranchForm($(this).val());
    });
    $(this.controlCurrency).on('change', function () {
      t.changeCurrencyForm($(this).val());
    });
    $(this.controlCountry).on('change', function () {
      t.changeCountryForm($(this).val());
    });
    $(this.controlFinality).on('change', function () {
      t.changeFinalityForm($(this).val());
    });
  }

  changeBranchForm(text: String) {
    this.orderForm.controls['branch'].patchValue(text);
  }

  changeCurrencyForm(text: String) {
    this.orderForm.controls['currency'].patchValue(text);
  }

  changeCountryForm(text: String) {
    this.orderForm.controls['country'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }
  
  changeEmailForm() {
    this.orderForm.controls['email'].patchValue(this.orderForm.controls['email'].value.trim())
  }


  changeFinalityForm(text: String) {
    this.orderForm.controls['finalityId'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }

  handleCopyinvoiceemail(e) {
    this.orderForm.controls['copyinvoiceemail'].patchValue(e.target.checked);
  }

  sendExistingInvoice() {
    this.loading = true;
    let order: AddExistingInvoiceDto = {
      currency: this.order.currency,
      amount: this.order.amount,
      finalityId: this.order.finalityId,
      corporateAccountId: this.order.corporateAccountId,
      sender: {
        companyName: this.order.companyName,
        country: this.order.country,
        email: this.order.email,
        copyinvoiceemail: this.order.copyinvoiceemail,
      },
      receiver: {
        branch: this.order.branch,
      },
    };
  
    this.ordersService.createOrderWithExistingInvoice(order).subscribe({
      next: (orderResult) => {
        this.loading = false;
        this.notifier.notify('success', 'Ordem criada com sucesso!');
        this.closeModal();
        this.ordersService.updateOrderView();
        this.openAttachInvoiceModal(orderResult.data);
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openNewOrderModal() {
    this.modalService.dismiss(null);
    this.modalService.present(NewOrderModalComponent);
  }

  openAttachInvoiceModal(order: InboundOrderDto) {
    this.modalService.dismiss(null);
    this.modalService.present(AttachInvoiceModalComponent, order);
  }
}
 